// extracted by mini-css-extract-plugin
export default {"chip":"feedScopeChip_chip__RaGNS","remove":"feedScopeChip_remove__h-bKf"};